<template>
  <div class="BackMessage">
    <transition name="BackMessage__content">
      <div class="BackMessage__content" v-if="active">
        <div class="BackMessage__container">
          <div class="BackMessage__text">
            {{  trans('sur') }}
          </div>
          <a href="/" class="Btn is-yes">{{ trans('yes') }}</a>
          <div class="Btn is-no" @click="no()">{{ trans('no') }}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'BackMessage',
  translations: {
    fr: { 'sur': 'Êtes vous sûre de vouloir quitter ?', yes: 'oui', no: 'non' },
    en: { 'sur': 'Are you sure you want to quit?', yes: 'yes', no: 'no' },
  },
  data: () => ({
    active: false,
    sure: false,
    resolve: null,
    reject: null
  }),
	methods: {
		show() {
		  this.active = true
		  this.sure = false
      return new Promise((res, rej) => {
        this.resolve = res
        this.reject = rej
      })
		},
    yes() {
      this.resolve()
      this.active = false
    },
    no() {
      this.reject()
      this.active = false
    }
	}
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.BackMessage

  &__content
    position fixed
    background rgba(black, .9)
    width 100vw
    height 100vh
    top 0px
    left 0px
    transition opacity 1s
    background-image url('~@/commons/img/smoke.png')
    background-size contain
    background-repeat no-repeat
    background-position center center
    &-enter
    &-leave-active
      opacity 0

  &__container
    position absolute
    background #0A0811
    padding 20px
    top 50%
    left 50%
    transform translate(-50%, -50%)
    color white
    width 600px
    text-align center

    .Btn
      position relative
      width 100px
      display inline-block
      right auto
      margin 0 10px
      &.is-yes
        background linear-gradient(to right, rgba(blue, 1), rgba(yellow, 1))
        color white

  &__text
    margin-bottom 50px
    padding 50px 0
</style>



// WEBPACK FOOTER //
// src/components/back-message/BackMessage.vue